// Pure model of the Vue login page (src/components/login), ported from the legacy login page
// (decommissioned/m.eagle/app/pages/login/login.js + login.htm, js/Main.js checkPassComplexity).
// Nothing here touches window, document or the iframe.

// login.htm panels: the main form, the forgotten password mail, the reset with the mailed key (?rp=1)
// and the expired password (Auth/Logon ERR-0096).
export const LOGIN_PANELS = ['main', 'forgotten', 'reset', 'expired'];

// login.htm language switch (localStorage.loginLocale, read by Globalization.js and src/i18n/bootstrap.js).
// Shown by their own names, like most language pickers: no translation key needed.
export const LOGIN_LANGUAGES = [
	{ locale: 'fr-FR', label: 'Français' },
	{ locale: 'en-GB', label: 'English' },
	{ locale: 'es-ES', label: 'Español' },
	{ locale: 'pt-PT', label: 'Português' },
	{ locale: 'nl-NL', label: 'Nederlands' },
	{ locale: 'de-DE', label: 'Deutsch' },
];

export const languageFlag = (locale) => `/m.eagle/img/flags/${locale}.png`;

// mdcControl.js uppercases the user name and customer code fields on every key stroke.
export const loginCode = (value) => String(value ?? '').toUpperCase();

// The required fields of each form (mdcControl.js disables the form button until they are filled) are Vuetify
// rules in LoginPage.vue: the `v-form` validity drives the buttons.

// The password rule is only known from an Auth error: its message ends with "|<lower>-<upper>-<num>-<special>-<length>".
export const NO_COMPLEXITY = '0-0-0-0-0';
export function parseComplexity(message) {
	const rule = String(message ?? '')
		.split('|')[1]
		?.trim();
	return rule && /^\d+-\d+-\d+-\d+-\d+$/.test(rule) ? rule : null;
}

// Main.js textHelper counters, kept as is (the special characters list counts ',' and not '-').
const count = (value, test) => [...value].filter(test).length;
const isLower = (c) => c === c.toLowerCase() && c !== c.toUpperCase();
const isUpper = (c) => c === c.toUpperCase() && c !== c.toLowerCase();
const SPECIAL = /[~,@,!,#,$,%,^,&,*,_,-,+,=,|,(,),{,},[,\],;,",',<,>,.,?,:]/;

export const COMPLEXITY_RULES = ['lower', 'upper', 'num', 'special', 'length'];

// Main.js checkPassComplexity(): which rules of "<lower>-<upper>-<num>-<special>-<length>" the password meets.
export function passwordComplexity(password, rule) {
	const value = String(password ?? '');
	const [lower, upper, num, special, length] = String(rule ?? NO_COMPLEXITY)
		.split('-')
		.map(Number);
	const checks = { lower: count(value, isLower) >= lower, upper: count(value, isUpper) >= upper, num: count(value, (c) => /[0-9]/.test(c)) >= num, special: count(value, (c) => SPECIAL.test(c)) >= special, length: value.length >= length };
	const required = { lower, upper, num, special, length };
	return { match: rule === NO_COMPLEXITY || Object.values(checks).every(Boolean), checks, required };
}
